import { DateTime } from "luxon";

export const getDate = (date: Date | number) => {
  return typeof date === "number" ? DateTime.fromMillis(date) : DateTime.fromJSDate(date);
};

export const shouldDisplayYear = (luxonDate: DateTime, now: DateTime | null = null) => {
  const luxonNow = now ?? DateTime.now();

  const threeMonthsFromNow = luxonNow.plus({ months: 3 });

  const isPast = luxonDate < luxonNow;
  const isMoreThanThreeMonthsAway = luxonDate > threeMonthsFromNow;
  const isDifferentYear = luxonDate.year !== luxonNow.year;

  return isPast || (isMoreThanThreeMonthsAway && isDifferentYear);
};

export const isMultiDayDate = (luxonStartDate: DateTime, luxonEndDate: DateTime) => {
  const isSameDay = luxonStartDate.startOf("day").equals(luxonEndDate.startOf("day"));
  const nextDay = luxonStartDate.plus({ days: 1 }).startOf("day");
  // We consider not multi-day if it not the same day but the start day is after 5pm not ending next day before 7am
  return !isSameDay && !(luxonStartDate.hour >= 17 && luxonEndDate < nextDay.plus({ hours: 7 }));
};

// Formats a DateTime with time and timezone abbreviation (e.g., "7:00 PM EST")
export const formatTimeWithTimezone = (luxonDate: DateTime, isoLocale: string): string => {
  const timeString = luxonDate.toLocaleString({ hour: "numeric", minute: "2-digit" }, { locale: isoLocale });
  const timezoneAbbr = luxonDate.offsetNameShort || luxonDate.toFormat("ZZZZ");
  return `${timeString} ${timezoneAbbr}`;
};
